import i18next from 'i18next';
import React from 'react';
import { IconButton } from 'src/components/atoms';
import { getReadableIdWithDash } from 'src/types';
import {
  Created,
  EventDetailsWrapper,
  ID,
  Row,
} from './DraftEventHeader.styles';

interface Props {
  id: string;
  created?: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DraftEventHeader = ({ id, created, isOpen, setIsOpen }: Props) => (
  <Row onClick={() => setIsOpen(!isOpen)}>
    <EventDetailsWrapper>
      <ID data-testid={`event-id/${id}`}>
        Event ID: {getReadableIdWithDash(id)}
      </ID>
      {created && (
        <Created data-testid={`event-created/${id}`}>
          Date Created: {new Date(created).toLocaleDateString(i18next.language)}
        </Created>
      )}
    </EventDetailsWrapper>
    <IconButton
      variant="tertiary"
      size="large"
      iconName={isOpen ? 'uil uil-angle-up' : 'uil uil-angle-down'}
      aria-label="expand-event"
      data-testid="expand-event"
    ></IconButton>
  </Row>
);
